import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from "../components/Header";
import Hero from "../components/Hero";
import ProfileCard from "../components/ProfileCard";
import { getProfiles } from "../redux/actions/profileActions";

const Landing = () => {
  const { profiles } = useSelector((state) => state.ProfileList);
  const dispatch = useDispatch();
  console.log({ profiles });
  useEffect(() => {
    dispatch(getProfiles());
  }, []);
  return (
    <div className="bg-slate-50 min-h-screen">
      <Header />
      <div className="flex md:flex-wrap md:flex-row space-y-7 items-center mx-3 my-6 flex-col">
        {profiles.map((x) => (
          <ProfileCard key={x.id} profile={x} />
        ))}
      </div>
    </div>
  );
};

export default Landing;
